import { Tooltip } from "@/components/ui/tooltip";
import { Indicator } from "./indicator";

/* Prop Types */
interface PriorityAlignmentOffsetIndicatorProps {
  offset: number;
  size?: "small" | "medium" | "large";
}

const getOffsetConfig = (offset: number) => {
  if (offset === 0) {
    return {
      bgClass: "#1d8510",
      tooltipTitle: "Aligned",
      tooltipContent: "Spot on - this element was viewed in the same priority as intended.",
    };
  }

  if (Math.abs(offset) === 1) {
    return {
      bgClass: "#F2994A",
      tooltipTitle: offset === 1 ? "Under-performing" : "Over-performing",
      tooltipContent: offset === 1 ? "This element received less attention than intended." : "This element received more attention than intended.",
    };
  }

  return {
    bgClass: "#f02e2e",
    tooltipTitle: "Misaligned",
    tooltipContent: offset > 1 ? "This element received much less attention than intended." : "This element received much more attention than intended.",
  };
};

/*
 * PriorityAlignmentOffsetIndicator component
 *
 * Indicator component to visually represent the rank and priority of a report.
 */
export const PriorityAlignmentOffsetIndicator = ({ offset, size = "small" }: PriorityAlignmentOffsetIndicatorProps) => {
  const { bgClass, tooltipTitle, tooltipContent } = getOffsetConfig(offset);

  /* Render */
  return (
    <Tooltip
      position="left"
      content={
        <div className="flex flex-col items-start gap-2 p-4">
          <div className="flex items-center">
            <Indicator color={bgClass} size={size} className="mr-2" />
            <p className="font-semibold text-base">{tooltipTitle}</p>
          </div>
          <p className="text-sm text-left">{tooltipContent}</p>
        </div>
      }
    >
      <Indicator color={bgClass} size={size} />
    </Tooltip>
  );
};
